import Notification_ from './../../Class/Notification'
import {
  Notification
} from 'element-ui';

const notifications = {
  state: {
    notifications: [],
    countUnseen: 0
  },
  mutations: {
    newNotification(state, payload) {
     
      console.log('NOTIFICATIONS ', payload);
      let found = state.notifications.find(fitem => {
        return fitem.id === payload.id;
      });
      if (!found) {
        if(!payload.seen) {
          Notification({
            type: payload.type,
            message: payload.message
          });
        }
        state.notifications.unshift(payload)
        state.countUnseen++;
      }


    },
    seen(state, payload) {
      if (Number.isInteger(payload) && payload < state.notifications.length)
        state.notifications[payload].seen = true;
    },
    seenAll(state, payload) {
      state.notifications.forEach((notification) => {
        notification.seen = true
      })
    },
    unSeenNotification(state) {
      state.countUnseen = state.notifications.filter(notification => notification.seen == false).length;
    }
  },
  getters: {
    notificationById: (state) => (id) => {
      return state.notifications.find(notification => notification.id === id);
    },
    notifications(state) {
      return state.notifications
    },
    unSeenNotification(state) {
      return state.notifications.filter(notification => notification.seen == false).length;
    }
  },
  actions: {
    newNotification(context, payload) {
      // if (!payload.seen) {
       

      // }
      context.commit('newNotification', new Notification_(payload));
    },
    unSeenNotification(context, payload) {
      context.commit('unSeenNotification', payload);
    },
    seen(context, payload) {
      context.commit('seen', payload);
    },
    seenAll(context, payload) {
      context.commit('seenAll', payload);
    }
  }
}
export default notifications



// WEBPACK FOOTER //
// ./src/store/modules/notifications.js